/*
 * -----------------------------------------------------------------------------------------
 * root.ts
 *
 * Copyright: (c) 2004-2020 Potthoff + Partner Unternehmensberatungs-Gesellschaft mbH
 *            All rights reserved.
 * -----------------------------------------------------------------------------------------
 * Erstellt : 13.10.2020
 * Autor    : Markus Plutka
 *
 * Geändert : 29.09.2021
 *      von : Markus Plutka
 * -----------------------------------------------------------------------------------------
 *
 * Changelog:
 *
 */

import { takeEvery, all } from "redux-saga/effects";

import { State } from "reducers/index";
import { INITIALIZE_REQUEST } from "reducers/application";
import applicationInitializeSaga from "./applicationInitializeSaga";
import { Store } from "redux";

const rootSaga = (store: Store<State>) => {

  function* saga(): IterableIterator<any> {
    yield all([
        takeEvery(INITIALIZE_REQUEST, applicationInitializeSaga)
    ]);
  }

  return saga;
};

export default rootSaga;
